module.exports = __webpack_public_path__ + "static/media/platinum_passport_lock354a368c4e0349a253a1a3048ce554b3.webp";